import {
  ADDITIONAL_INFORMATION_STATUS,
  AdditionalInformation,
} from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

import {
  type AcceptSuggestionAction,
  type FieldSuggestion,
  type RejectSuggestionAction,
  type UpdateSuggestionAction,
} from 'hb-react/shared/components/AIFormWidget/types';
import { HtmlContent } from 'hb-react/shared/components/HtmlContent';

import { Title } from './ui';
import { Actions } from '../../Actions';
import { HistoryNavigation } from '../../HistoryNavigation';

interface PendingStateProps {
  acceptSuggestion: AcceptSuggestionAction;
  navigateHistory: (index: number) => void;
  rejectSuggestion: RejectSuggestionAction;
  suggestion: FieldSuggestion;
  suggestionWithHistory: FieldSuggestion;
  updateSuggestion: UpdateSuggestionAction;
}

export const PendingState = ({
  suggestion,
  suggestionWithHistory,
  acceptSuggestion,
  rejectSuggestion,
  updateSuggestion,
  navigateHistory,
}: PendingStateProps) => (
  <Box flexDirection="column" gridRowGap={3} textAlign="left">
    <Box justifyContent="space-between">
      <Title title={suggestion?.schema?.label || suggestion.fieldName} />

      <Box alignItems="center">
        <HistoryNavigation
          suggestion={suggestionWithHistory}
          onNavigate={navigateHistory}
        />
      </Box>
    </Box>

    <Box flexDirection="column" gridRowGap={2} textAlign="left">
      <Box
        p={4}
        bg="lightestGrey"
        font="body-regular-asphalt"
        style={{
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          lineHeight: '1.6',
          textAlign: 'left',
        }}
      >
        {suggestion.schema.type === 'html' ? (
          <HtmlContent content={suggestion.suggestedValue} stylesConfig="web" />
        ) : (
          suggestion.suggestedValue
        )}
      </Box>

      <AdditionalInformation
        id={`suggestion-reasoning-${suggestion.id}`}
        status={ADDITIONAL_INFORMATION_STATUS.INFO}
      >
        {suggestion.reasoning}
      </AdditionalInformation>
    </Box>

    <Actions
      suggestion={suggestionWithHistory}
      acceptSuggestion={acceptSuggestion}
      rejectSuggestion={rejectSuggestion}
      updateSuggestion={updateSuggestion}
    />
  </Box>
);
